/* Livset Pazar — ortak JS (bağımlılıksız). Sayfa özel dosyalar: facets.js, product.js, cart.js */
(() => {
  const L = (window.Livset = window.Livset || {});
  const cfg = L.config || { routes: {}, strings: {} };
  const S = cfg.strings || {};

  /* ---------- Yardımcılar ---------- */
  L.formatMoney = (cents) => {
    const value = Number(cents) / 100;
    if (cfg.currency && cfg.currency !== 'TRY') {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr', { style: 'currency', currency: cfg.currency }).format(value);
    }
    const hasCents = Math.round(cents) % 100 !== 0;
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: 2 }).format(value) + ' TL';
  };
  L.cartPrice = (cents) => Math.floor((Number(cents) * (100 - (cfg.cartDiscountPercent || 0))) / 100);
  L.emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  L.debounce = (fn, ms = 250) => {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  };
  L.fetchSection = async (url, sectionId) => {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    const res = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error(res.status);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };

  /* ---------- Toast ---------- */
  L.toast = ({ message, image, actionLabel, actionUrl, icon = true, duration = 4000 }) => {
    const region = document.querySelector('[data-toast-region]');
    if (!region) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    if (image) {
      const img = document.createElement('img');
      img.className = 'toast__img';
      img.src = image;
      img.alt = '';
      el.append(img);
    } else if (icon) {
      el.insertAdjacentHTML('beforeend', '<span class="toast__icon"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>');
    }
    const msg = document.createElement('span');
    msg.className = 'toast__msg';
    msg.textContent = message;
    el.append(msg);
    if (actionLabel && actionUrl) {
      const a = document.createElement('a');
      a.className = 'toast__action';
      a.href = actionUrl;
      a.textContent = actionLabel;
      el.append(a);
    }
    region.append(el);
    const remove = () => {
      el.classList.add('is-leaving');
      el.addEventListener('animationend', () => el.remove(), { once: true });
    };
    setTimeout(remove, duration);
    while (region.children.length > 2) region.firstElementChild.remove();
  };

  /* ---------- Sepet ---------- */
  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
    });
  };
  L.cart = {
    async get() {
      const res = await fetch(`${cfg.routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    async add(items, { sections } = {}) {
      const body = { items: Array.isArray(items) ? items : [items] };
      if (sections) {
        body.sections = sections;
        body.sections_url = location.pathname;
      }
      const res = await fetch(`${cfg.routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw Object.assign(new Error(data.description || data.message || S.error), { data });
      const cart = await L.cart.get();
      updateCartCount(cart.item_count);
      L.emit('cart:updated', { cart, added: data });
      return data;
    },
    async change(line, quantity, { sections } = {}) {
      const body = { line, quantity };
      if (sections) {
        body.sections = sections;
        body.sections_url = location.pathname;
      }
      const res = await fetch(`${cfg.routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const cart = await res.json();
      if (!res.ok) throw Object.assign(new Error(cart.description || cart.message || S.error), { data: cart });
      updateCartCount(cart.item_count);
      L.emit('cart:updated', { cart });
      return cart;
    }
  };
  L.addedToast = (item) => {
    L.toast({
      message: S.added,
      image: item && item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=120` : null,
      actionLabel: S.goToCart,
      actionUrl: cfg.routes.cart || '/cart'
    });
  };

  /* Ürün formları (data-product-form): AJAX ile ekle + toast */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    if (!fd.get('id')) {
      const scope = form.closest('[data-product-scope]') || document;
      const picker = scope.querySelector('variant-picker');
      if (picker && picker.flagMissing) picker.flagMissing();
      else L.toast({ message: S.chooseVariant, icon: false });
      return;
    }
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    btn && btn.setAttribute('aria-busy', 'true');
    btn && (btn.disabled = true);
    try {
      const data = await L.cart.add(item);
      const added = (data.items && data.items[0]) || data;
      form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: added }));
      L.afterAdd(added);
    } catch (err) {
      L.toast({ message: err.message || S.error, icon: false });
    } finally {
      btn && btn.removeAttribute('aria-busy');
      btn && (btn.disabled = false);
    }
  });

  /* ---------- Favoriler (localStorage) ---------- */
  const FAV_KEY = 'livset:favs';
  const readFavs = () => {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (_) { return []; }
  };
  const writeFavs = (list) => {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (_) { /* gizli mod */ }
  };
  L.favs = {
    all: readFavs,
    has: (h) => readFavs().includes(h),
    toggle(handle) {
      const list = readFavs();
      const i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1);
      else list.unshift(handle);
      writeFavs(list.slice(0, 100));
      L.favs.sync();
      L.emit('favs:changed', { handle, active: i === -1, list });
      return i === -1;
    },
    sync(root = document) {
      const list = readFavs();
      root.querySelectorAll('[data-fav-toggle]').forEach((btn) => {
        const on = list.includes(btn.dataset.handle);
        btn.setAttribute('aria-pressed', String(on));
        btn.setAttribute('aria-label', on ? S.favRemove : S.favAdd);
      });
      document.querySelectorAll('[data-fav-count]').forEach((el) => {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    }
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    const on = L.favs.toggle(btn.dataset.handle);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (on) btn.classList.add('is-pop');
    L.toast({ message: on ? S.favAdded : S.favRemoved, duration: 2200 });
  });
  window.addEventListener('storage', (e) => e.key === FAV_KEY && L.favs.sync());

  /* ---------- Ertelenmiş görseller (çekmece / açılır menü) ---------- */
  L.loadDeferred = (root) => {
    root.querySelectorAll('img[data-src]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  };
  ['pointerenter', 'focusin'].forEach((ev) => document.addEventListener(ev, (e) => {
    const item = e.target.closest && e.target.closest('.has-mega');
    if (item) L.loadDeferred(item);
  }, true));

  /* ---------- Drawer ---------- */
  class XDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.drawer__panel');
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) this.close();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trap(e);
      });
    }
    open(opener) {
      this.opener = opener || document.activeElement;
      L.loadDeferred(this);
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => (this.panel || this).focus());
      L.emit('drawer:open', { id: this.id });
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('x-drawer.is-open')) document.body.classList.remove('is-locked');
      this.opener && this.opener.focus && this.opener.focus({ preventScroll: true });
    }
    trap(e) {
      const f = [...this.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  customElements.define('x-drawer', XDrawer);
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (!opener) return;
    const drawer = document.getElementById(opener.dataset.drawerOpen);
    if (drawer && drawer.open) {
      e.preventDefault();
      drawer.open(opener);
    }
  });

  /* ---------- Scroll slider ---------- */
  class ScrollSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prev = this.querySelector(':scope > [data-prev]');
      this.next = this.querySelector(':scope > [data-next]');
      this.dots = [...this.querySelectorAll(':scope > [data-dots] [data-dot]')];
      this.prev && this.prev.addEventListener('click', () => this.go(-1));
      this.next && this.next.addEventListener('click', () => this.go(1));
      this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(Number(d.dataset.dot))));
      this.track.addEventListener('scroll', L.debounce(() => this.update(), 60), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.track);
      this.update();
      const sec = Number(this.dataset.autoplay || 0);
      if (sec > 0 && this.slides().length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.autoplay(sec * 1000);
      }
    }
    slides() { return [...this.track.children]; }
    index() {
      const w = this.track.clientWidth;
      return w ? Math.round(this.track.scrollLeft / w) : 0;
    }
    goTo(i) {
      const s = this.slides()[i];
      if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
    go(dir) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth - 2;
      if (this.hasAttribute('data-loop') && dir > 0 && t.scrollLeft >= max) return t.scrollTo({ left: 0, behavior: 'smooth' });
      if (this.hasAttribute('data-loop') && dir < 0 && t.scrollLeft <= 2) return t.scrollTo({ left: t.scrollWidth, behavior: 'smooth' });
      const first = this.slides()[0];
      const step = this.dots.length ? t.clientWidth : Math.max(first ? first.getBoundingClientRect().width : t.clientWidth, t.clientWidth - (first ? first.getBoundingClientRect().width : 0));
      t.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const loop = this.hasAttribute('data-loop');
      if (this.prev) this.prev.disabled = !loop && t.scrollLeft <= 2;
      if (this.next) this.next.disabled = !loop && t.scrollLeft >= max - 2;
      if (max <= 2) { this.prev && (this.prev.hidden = true); this.next && (this.next.hidden = true); }
      else { this.prev && (this.prev.hidden = false); this.next && (this.next.hidden = false); }
      const i = this.index();
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }
    autoplay(ms) {
      let timer;
      const start = () => { stop(); timer = setInterval(() => this.go(1), ms); };
      const stop = () => clearInterval(timer);
      ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, stop, { passive: true }));
      ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, start));
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      start();
    }
  }
  customElements.define('scroll-slider', ScrollSlider);

  /* ---------- Tabs ---------- */
  class TabGroup extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll(':scope > [data-panel]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(n);
            this.tabs[n].focus();
          }
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', String(n === i));
        t.tabIndex = n === i ? 0 : -1;
      });
      this.panels.forEach((p, n) => (p.hidden = n !== i));
    }
  }
  customElements.define('tab-group', TabGroup);

  /* ---------- Duyuru döndürücü ---------- */
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      const items = [...this.children];
      if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      const ms = Number(this.dataset.interval || 5) * 1000;
      let timer = setInterval(() => step(), ms);
      const step = () => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      };
      this.addEventListener('pointerenter', () => clearInterval(timer));
      this.addEventListener('pointerleave', () => { clearInterval(timer); timer = setInterval(step, ms); });
    }
  }
  customElements.define('announcement-rotator', AnnouncementRotator);

  /* ---------- Devamını oku ---------- */
  class ReadMore extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-readmore-toggle]');
      const body = this.querySelector('[data-readmore-body]');
      if (!btn || !body) return;
      requestAnimationFrame(() => {
        if (body.scrollHeight <= body.clientHeight + 4) {
          this.classList.remove('is-collapsible');
          btn.hidden = true;
        }
      });
      btn.addEventListener('click', () => {
        const open = this.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    }
  }
  customElements.define('read-more', ReadMore);

  /* ---------- Predictive search ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results || !cfg.routes.predictiveSearch) return;
      this.input.addEventListener('input', L.debounce(() => this.search(), 220));
      this.input.addEventListener('focus', () => this.input.value.trim().length > 1 && this.search());
      document.addEventListener('click', (e) => !this.contains(e.target) && this.close());
      this.addEventListener('keydown', (e) => e.key === 'Escape' && (this.close(), this.input.blur()));
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) return this.close();
      this.abort && this.abort.abort();
      this.abort = new AbortController();
      try {
        const url = `${cfg.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag`;
        const res = await fetch(url, { signal: this.abort.signal });
        if (!res.ok) return this.close();
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = html.querySelector('[data-predictive-inner]');
        this.results.innerHTML = inner ? inner.innerHTML : '';
        this.open();
      } catch (_) { /* yeni sorgu iptal etti */ }
    }
    open() {
      if (!this.results.innerHTML.trim()) return this.close();
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* ---------- Varyant seçici ---------- */
  // "160 x 230" → [160, 230]
  const sizeDims = (v) => {
    const m = String(v).match(/(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i);
    return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null;
  };
  const ROOM_KEY = 'livset:room';
  const readRoom = () => {
    try { return JSON.parse(localStorage.getItem(ROOM_KEY)) || null; } catch (_) { return null; }
  };
  const writeRoom = (room) => {
    try { localStorage.setItem(ROOM_KEY, JSON.stringify(room)); } catch (_) { /* gizli mod */ }
  };

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      const low = this.querySelector('[data-low-stock]');
      try { this.low = low ? JSON.parse(low.textContent) : {}; } catch (_) { this.low = {}; }
      this.stockLine = this.querySelector('[data-stock-line]');
      this.scope = this.closest('[data-product-scope]') || document;
      this.groups = [...this.querySelectorAll('[data-option-index]')];
      this.groups.filter((g) => g.classList.contains('vp__group--size')).forEach((g) => this.arrangeSizes(g));
      this.addEventListener('change', (e) => e.target.matches('.vp__input') && this.onChange(false));
      this.onChange(true);
      this.groups.forEach((g) => g.querySelector('[data-room]') && this.setupRoom(g));
    }
    arrangeSizes(g) {
      const wrap = g.querySelector('.vp__values');
      const pairs = [...wrap.querySelectorAll('.vp__input')].map((inp) => [inp, inp.nextElementSibling]);
      const dims = sizeDims;
      if (pairs.length > 1 && pairs.every(([i]) => dims(i.value))) {
        pairs.sort((a, b) => {
          const [aw, ah] = dims(a[0].value);
          const [bw, bh] = dims(b[0].value);
          return aw * ah - bw * bh || aw - bw;
        });
        pairs.forEach(([i, l]) => wrap.append(i, l));
      }
      const LIMIT = 12;
      if (pairs.length > LIMIT + 3) {
        g.classList.add('is-collapsed');
        pairs.forEach(([i, l], n) => { if (n >= LIMIT) { l.classList.add('vp__chip--extra'); i.classList.add('vp__input--extra'); } });
        const more = document.createElement('button');
        more.type = 'button';
        more.className = 'vp__more';
        more.textContent = (S.moreSizes || '+[n]').replace('[n]', pairs.length - LIMIT);
        more.addEventListener('click', () => {
          g.classList.remove('is-collapsed');
          more.remove();
        });
        wrap.after(more);
      }
    }
    selected() {
      return this.groups.map((g) => {
        const c = g.querySelector('.vp__input:checked');
        return c ? c.value : null;
      });
    }
    find(opts) {
      return this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    onChange(initial) {
      const opts = this.selected();
      const complete = opts.every((o) => o != null);
      const variant = complete ? this.find(opts) : null;
      this.groups.forEach((g, i) => {
        const label = g.querySelector('[data-selected-label]');
        if (label) label.textContent = opts[i] || '';
        g.classList.toggle('is-chosen', opts[i] != null);
        g.classList.remove('is-missing');
        g.querySelectorAll('.vp__input').forEach((inp) => {
          const test = opts.slice();
          test[i] = inp.value;
          const candidates = this.variants.filter((v) => v.options.every((o, n) => test[n] == null || o === test[n]));
          const chip = inp.nextElementSibling;
          const exists = candidates.length > 0;
          const available = candidates.some((v) => v.available);
          chip.classList.toggle('is-missing', !exists);
          chip.classList.toggle('is-unavailable', exists && !available);
          const priceEl = chip.querySelector('.vp__price');
          if (priceEl) {
            const prices = candidates.map((v) => v.price);
            priceEl.textContent = prices.length ? L.formatMoney(Math.min(...prices)) : '';
          }
          // Gerçek stok: seçenek tek bir varyanta karşılık geliyorsa ve adedi eşiğin altındaysa
          const qty = candidates.length === 1 && candidates[0].available ? this.low[candidates[0].id] : 0;
          let stockEl = chip.querySelector('.vp__stock');
          if (qty && !stockEl) {
            stockEl = document.createElement('small');
            stockEl.className = 'vp__stock';
            chip.append(stockEl);
          }
          if (stockEl) {
            stockEl.hidden = !qty;
            stockEl.textContent = qty ? (S.lowStockChip || '[n]').replace('[n]', qty) : '';
          }
        });
      });
      const left = variant && variant.available ? this.low[variant.id] : 0;
      if (this.stockLine) {
        this.stockLine.hidden = !left;
        this.stockLine.querySelector('span').textContent = left ? (S.lowStockLine || '[n]').replace('[n]', left) : '';
      }
      this.variant = variant;
      this.updateScope(variant, complete);
      this.roomRun && this.roomRun(false);
      if (!initial) {
        this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
        if (this.dataset.updateUrl === 'true' && variant) {
          history.replaceState(history.state, '', `${this.dataset.url}?variant=${variant.id}`);
        }
      }
    }
    updateScope(v, complete) {
      const s = this.scope;
      s.querySelectorAll('[data-variant-id]').forEach((i) => (i.value = v ? v.id : ''));
      s.querySelectorAll('[data-atc]').forEach((b) => {
        const txt = b.querySelector('[data-atc-text]') || b;
        if (!complete) {
          b.disabled = false;
          txt.textContent = b.dataset.add;
        } else if (!v) {
          b.disabled = true;
          txt.textContent = b.dataset.unavailable;
        } else {
          b.disabled = !v.available;
          txt.textContent = v.available ? b.dataset.add : b.dataset.soldout;
        }
      });
      if (!v) return;
      s.querySelectorAll('[data-price-current]').forEach((e) => (e.textContent = L.formatMoney(v.price)));
      s.querySelectorAll('[data-sku]').forEach((e) => {
        e.textContent = v.sku || '';
        const row = e.closest('.pdp__sku');
        if (row) row.hidden = !v.sku;
      });
      s.querySelectorAll('.price__from').forEach((e) => (e.hidden = true));
      s.querySelectorAll('[data-price-compare]').forEach((e) => {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        e.hidden = !sale;
        e.textContent = sale ? L.formatMoney(v.compare_at_price) : '';
        const block = e.closest('.price');
        block && block.classList.toggle('price--sale', !!sale);
      });
      s.querySelectorAll('[data-price-cart-amount]').forEach((e) => (e.textContent = L.formatMoney(L.cartPrice(v.price))));
    }
    /* Odana göre ebat: alanın her kenarında kısa kenarın ~%8'i kadar (10-30 cm) boşluk bırakan
       en büyük stoktaki ebat önerilir; sığmayan ebatlar soluklaşır. Ölçü tarayıcıda hatırlanır. */
    setupRoom(g) {
      const box = g.querySelector('[data-room]');
      const toggle = box.querySelector('[data-room-toggle]');
      const panel = box.querySelector('[data-room-panel]');
      const inW = box.querySelector('[data-room-w]');
      const inL = box.querySelector('[data-room-l]');
      const out = box.querySelector('[data-room-result]');
      const items = [...g.querySelectorAll('.vp__input')].map((inp) => ({ inp, chip: inp.nextElementSibling, d: sizeDims(inp.value) }));
      if (items.filter((it) => it.d).length < 2) return box.remove();
      const clear = () => {
        g.classList.remove('has-room');
        items.forEach(({ chip }) => { chip.classList.remove('is-best', 'is-toobig'); chip.removeAttribute('title'); });
        out.textContent = '';
      };
      const run = (save) => {
        const w = parseFloat(inW.value);
        const l = parseFloat(inL.value);
        if (!(w >= 40 && l >= 40)) {
          if (save) out.textContent = S.roomInvalid || '';
          return;
        }
        const rw = Math.min(w, l);
        const rl = Math.max(w, l);
        const pad = Math.min(30, Math.max(10, rw * 0.08));
        if (save) writeRoom({ w, l, on: true });
        clear();
        g.classList.add('has-room');
        let best = null;
        let smallest = null;
        items.forEach((it) => {
          if (!it.d || it.chip.classList.contains('is-missing')) return;
          const a = Math.min(...it.d);
          const b = Math.max(...it.d);
          const fits = a <= rw - 2 * pad && b <= rl - 2 * pad;
          it.chip.classList.toggle('is-toobig', !fits);
          if (!fits) it.chip.title = S.roomTooBig || '';
          if (!smallest || a * b < smallest.area) smallest = { ...it, area: a * b };
          if (fits && !it.chip.classList.contains('is-unavailable') && (!best || a * b > best.area)) best = { ...it, area: a * b };
        });
        const room = `${w} × ${l}`;
        out.textContent = '';
        if (best) {
          best.chip.classList.add('is-best');
          best.chip.dataset.best = S.roomBadge || '';
          if (best.chip.classList.contains('vp__chip--extra')) {
            g.classList.remove('is-collapsed');
            const more = g.querySelector('.vp__more');
            more && more.remove();
          }
          out.append((S.roomBest || '').replace('[room]', room).replace('[size]', best.inp.value) + ' ');
          if (!best.inp.checked) {
            const pick = document.createElement('button');
            pick.type = 'button';
            pick.className = 'vp-room__pick';
            pick.textContent = S.roomPick || '';
            pick.addEventListener('click', () => {
              best.inp.checked = true;
              best.inp.dispatchEvent(new Event('change', { bubbles: true }));
            });
            out.append(pick);
          }
        } else if (smallest) {
          out.textContent = (S.roomNone || '').replace('[room]', room).replace('[size]', smallest.inp.value);
        }
      };
      const show = (open) => {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) clear();
      };
      toggle.addEventListener('click', () => {
        const open = panel.hidden;
        show(open);
        const saved = readRoom();
        if (saved) writeRoom({ ...saved, on: open });
        if (open) {
          if (inW.value && inL.value) run(false);
          else inW.focus();
        }
      });
      box.querySelector('[data-room-go]').addEventListener('click', () => run(true));
      [inW, inL].forEach((inp) => inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); run(true); }
      }));
      this.roomRun = (save) => g.classList.contains('has-room') && run(save);
      const saved = readRoom();
      if (saved && saved.w && saved.l) {
        inW.value = saved.w;
        inL.value = saved.l;
        if (saved.on !== false) { show(true); run(false); }
      }
    }
    flagMissing() {
      const missing = this.groups.filter((g) => !g.querySelector('.vp__input:checked'));
      missing.forEach((g) => {
        g.classList.remove('is-missing');
        void g.offsetWidth;
        g.classList.add('is-missing');
      });
      if (missing[0]) {
        missing[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        const first = missing[0].querySelector('.vp__input:not(:disabled)');
        first && first.focus({ preventScroll: true });
      }
      L.toast({ message: S.chooseVariant, icon: false, duration: 2500 });
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ---------- Çerez bildirimi ---------- */
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (_) { /* gizli mod */ } }
  };
  // Çerez onayı: seçim Shopify Customer Privacy API'ye iletilir (pikseller buna uyar)
  const withPrivacyApi = (cb) => {
    const sh = window.Shopify;
    if (sh && sh.customerPrivacy) return cb(sh.customerPrivacy);
    if (sh && sh.loadFeatures) {
      sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => cb(err ? null : window.Shopify.customerPrivacy));
    } else cb(null);
  };
  class CookieNotice extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-cookie-accept]').addEventListener('click', () => this.decide(true));
      this.querySelector('[data-cookie-reject]').addEventListener('click', () => this.decide(false));
      withPrivacyApi((cp) => {
        this.cp = cp;
        let decided = store.get('livset:cookie');
        if (cp && cp.currentVisitorConsent) {
          const c = cp.currentVisitorConsent() || {};
          if (c.analytics === 'yes' || c.analytics === 'no') decided = decided || c.analytics;
        }
        // Shopify'ın kendi çerez banner'ı açıksa ikinci bir bildirim gösterme
        setTimeout(() => {
          if (decided || document.getElementById('shopify-pc__banner')) return;
          this.hidden = false;
          document.body.classList.add('has-cookie');
        }, 800);
      });
    }
    decide(accepted) {
      store.set('livset:cookie', accepted ? 'yes' : 'no');
      this.hidden = true;
      document.body.classList.remove('has-cookie');
      const apply = (cp) => cp && cp.setTrackingConsent && cp.setTrackingConsent(
        { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
        () => L.emit('consent:changed', { accepted })
      );
      this.cp ? apply(this.cp) : withPrivacyApi(apply);
    }
  }
  customElements.define('cookie-notice', CookieNotice);

  // Shopify çerez banner'ı açık bölgelerde footer'daki "Çerez tercihleri" paneli yeniden açar
  // (onayı geri almak verildiği kadar kolay olmalı). API yoksa bağlantı gizli kalır.
  const prefsItem = document.querySelector('[data-cookie-prefs-item]');
  if (prefsItem) {
    const canShow = () => !!(window.privacyBanner && window.privacyBanner.showPreferences);
    const reveal = () => { if (canShow()) prefsItem.hidden = false; return canShow(); };
    window.addEventListener('load', () => { if (!reveal()) setTimeout(reveal, 2500); }, { once: true });
    prefsItem.addEventListener('click', () => canShow() && window.privacyBanner.showPreferences());
  }

  // Zorunlu onay kutuları: eksikse kutuyu vurgula ve görünür yap
  document.addEventListener('invalid', (e) => {
    const box = e.target.closest && e.target.closest('.consent');
    if (!box) return;
    box.classList.add('is-invalid');
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
  document.addEventListener('change', (e) => {
    const box = e.target.closest && e.target.closest('.consent');
    if (box && e.target.checked) box.classList.remove('is-invalid');
  });

  /* ---------- Bülten popup'ı ---------- */
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.dialog.querySelector('[data-npop-close]').addEventListener('click', () => this.dismiss());
      this.dialog.addEventListener('cancel', () => this.dismiss());
      this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.dismiss());
      this.form = this.querySelector('[data-npop-form]');
      this.form && this.form.addEventListener('submit', (e) => this.submit(e));
      const posted = /[?&]customer_posted=true/.test(location.search);
      if (posted) store.set('livset:npop', 'done');
      // Doğrulama (captcha) nedeniyle normal gönderime düşüldüyse dönüşte kodu göster
      if (posted && (location.hash === '#NewsletterPopupForm' || store.get('livset:npop-pending'))) {
        try { localStorage.removeItem('livset:npop-pending'); } catch (_) { /* yok */ }
        this.showReward();
        return this.open();
      }
      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => this.contains(e.target) || e.target.contains(this) ? this.open() : null);
        return;
      }
      if (this.hasAttribute('data-disabled')) return;
      const state = store.get('livset:npop');
      if (state === 'done' || (state && Date.now() < Number(state))) return;
      setTimeout(() => {
        if (!document.querySelector('x-drawer.is-open, dialog[open]')) this.open();
      }, Number(this.dataset.delay || 12) * 1000);
    }
    async submit(e) {
      e.preventDefault();
      const form = this.form;
      const btn = form.querySelector('[type="submit"]');
      const err = form.querySelector('[data-npop-error]');
      if (!form.reportValidity()) return;
      btn && btn.setAttribute('aria-busy', 'true');
      err && (err.hidden = true);
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (/\/challenge/.test(res.url)) throw new Error('challenge');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const ok = /customer_posted=true/.test(res.url) || doc.querySelector('#NewsletterPopupForm [data-npop-success]');
        if (ok) {
          store.set('livset:npop', 'done');
          this.showReward();
          return;
        }
        const msg = doc.querySelector('#NewsletterPopupForm [data-npop-error]');
        if (err) {
          err.textContent = (msg && msg.textContent.trim()) || S.subscribeError;
          err.hidden = false;
        }
      } catch (_) {
        // Shopify doğrulama istiyor: normal gönderim, dönüşte kod gösterilir
        store.set('livset:npop-pending', '1');
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        btn && btn.removeAttribute('aria-busy');
      }
    }
    showReward() {
      const reward = this.querySelector('[data-npop-reward]');
      if (!reward || !reward.querySelector('[data-reward]')) return;
      this.form && (this.form.hidden = true);
      this.querySelectorAll('.npop__text, .npop__note').forEach((el) => (el.hidden = true));
      reward.hidden = false;
    }
    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.body.classList.add('is-locked');
    }
    dismiss() {
      const days = Number(this.dataset.days || 7);
      if (store.get('livset:npop') !== 'done') store.set('livset:npop', String(Date.now() + days * 864e5));
      this.dialog.close();
      document.body.classList.remove('is-locked');
    }
  }
  customElements.define('newsletter-popup', NewsletterPopup);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    try {
      await navigator.clipboard.writeText(btn.dataset.copyCode);
    } catch (_) {
      const tmp = document.createElement('textarea');
      tmp.value = btn.dataset.copyCode;
      document.body.append(tmp);
      tmp.select();
      document.execCommand('copy');
      tmp.remove();
    }
    L.toast({ message: S.codeCopied, duration: 2200 });
  });

  /* ---------- Favoriler sayfası ---------- */
  class FavoritesPage extends HTMLElement {
    async connectedCallback() {
      this.grid = this.querySelector('[data-fav-grid]');
      this.empty = this.querySelector('[data-fav-empty]');
      this.loading = this.querySelector('[data-fav-loading]');
      this.total = this.querySelector('[data-fav-total]');
      const root = this.dataset.root || '/';
      const handles = L.favs.all();
      if (!handles.length) return this.done();
      const results = await Promise.allSettled(handles.map(async (h) => {
        const res = await fetch(`${root}products/${encodeURIComponent(h)}?section_id=fav-card`);
        if (!res.ok) throw new Error(h);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const li = doc.querySelector('[data-fav-card]');
        if (!li) throw new Error(h);
        return li;
      }));
      results.forEach((r) => r.status === 'fulfilled' && this.grid.append(document.importNode(r.value, true)));
      // Silinmiş ürünleri listeden temizle
      const missing = handles.filter((h, i) => results[i].status === 'rejected');
      missing.forEach((h) => L.favs.has(h) && L.favs.toggle(h));
      L.favs.sync(this);
      this.done();
      document.addEventListener('favs:changed', (e) => {
        if (e.detail.active) return;
        const card = this.grid.querySelector(`[data-fav-card][data-handle="${CSS.escape(e.detail.handle)}"]`);
        card && card.remove();
        this.done();
      });
    }
    done() {
      this.loading && (this.loading.hidden = true);
      const n = this.grid.children.length;
      this.empty.hidden = n > 0;
      if (this.total) this.total.textContent = n ? `(${n})` : '';
    }
  }
  customElements.define('favorites-page', FavoritesPage);

  /* ---------- Ürün önerileri (görünür olunca yüklenir) ---------- */
  class ProductRecs extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-recs-inner]') || !this.dataset.url) return;
      const io = new IntersectionObserver(async (entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        try {
          const res = await fetch(this.dataset.url);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const inner = doc.querySelector('[data-recs-inner]');
          if (inner) {
            this.append(document.importNode(inner, true));
            L.favs.sync(this);
          }
        } catch (_) { /* öneri yoksa bölüm boş kalır */ }
      }, { rootMargin: '500px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recs', ProductRecs);

  /* ---------- Videolu ürünler: ekranda sessiz oynat, ses düğmesi ---------- */
  class VideoStories extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('[data-vs-video]')];
      if (!this.videos.length) return;
      // Kapak görselleri bölüm yaklaşınca yüklenir (poster niteliği tarayıcıda hemen iner)
      const near = new IntersectionObserver((entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        near.disconnect();
        this.videos.forEach((v) => {
          if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }
        });
      }, { rootMargin: '200px 0px' });
      near.observe(this);
      // Hareket azaltma ya da veri tasarrufu açıksa oynatma yok: kapak görseli kalır
      const saveData = navigator.connection && navigator.connection.saveData;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || saveData) return;
      this.buttons = [...this.querySelectorAll('[data-vs-sound]')];
      this.buttons.forEach((b) => (b.hidden = false));
      // Aynı anda en fazla 3 (mobilde 2) video oynar; sesi açılan video önceliklidir
      this.visible = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) this.visible.add(en.target);
          else this.visible.delete(en.target);
        });
        this.syncPlayback();
      }, { threshold: [0, 0.6] });
      this.videos.forEach((v) => io.observe(v));
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vs-sound]');
        if (!btn) return;
        e.preventDefault();
        const video = btn.closest('.vs-card').querySelector('[data-vs-video]');
        const turnOn = video.muted;
        this.videos.forEach((v) => (v.muted = true));
        this.buttons.forEach((b) => {
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', S.vsUnmute || '');
        });
        if (turnOn) {
          video.muted = false;
          this.visible.add(video);
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', S.vsMute || '');
        }
        this.syncPlayback();
      });
    }
  }
  VideoStories.prototype.syncPlayback = function syncPlayback() {
    const max = matchMedia('(min-width: 990px)').matches ? 3 : 2;
    let playing = 0;
    [...this.videos].sort((a, b) => Number(a.muted) - Number(b.muted)).forEach((v) => {
      if (this.visible.has(v) && playing < max) {
        playing++;
        if (v.paused) v.play().catch(() => { /* tarayıcı engelledi */ });
      } else if (!v.paused) v.pause();
    });
  };
  customElements.define('video-stories', VideoStories);

  /* ---------- Son baktığın ürünler (localStorage) ---------- */
  const RECENT_KEY = 'livset:recent';
  L.recent = {
    all() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (_) { return []; }
    },
    add(handle) {
      const list = L.recent.all().filter((h) => h !== handle);
      list.unshift(handle);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 20))); } catch (_) { /* gizli mod */ }
    },
    clear() {
      try { localStorage.removeItem(RECENT_KEY); } catch (_) { /* gizli mod */ }
    }
  };
  const fetchCards = async (handles, root) => {
    const results = await Promise.allSettled(handles.map(async (h) => {
      const res = await fetch(`${root}products/${encodeURIComponent(h)}?section_id=fav-card`);
      if (!res.ok) throw new Error(h);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const li = doc.querySelector('[data-fav-card]');
      if (!li) throw new Error(h);
      return li;
    }));
    return results.map((r) => (r.status === 'fulfilled' ? r.value : null));
  };
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const exclude = this.dataset.exclude;
      const handles = L.recent.all().filter((h) => h && h !== exclude).slice(0, Number(this.dataset.limit) || 10);
      if (!handles.length) return;
      const io = new IntersectionObserver(async (entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        const cards = await fetchCards(handles, this.dataset.root || '/');
        const tpl = this.querySelector('template[data-rv-tpl]');
        if (!tpl) return;
        const frag = tpl.content.cloneNode(true);
        const track = frag.querySelector('[data-track]');
        cards.forEach((li) => {
          if (!li) return;
          const slide = document.importNode(li, true);
          slide.className = 'slider__slide pcar__slide';
          track.append(slide);
        });
        if (!track.children.length) return;
        tpl.after(frag);
        this.hidden = false;
        L.favs.sync(this);
      }, { rootMargin: '400px 0px' });
      this.hidden = true;
      io.observe(this.parentElement || this);
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-rv-clear]')) return;
        L.recent.clear();
        this.hidden = true;
      });
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);

  /* ---------- Sepet çekmecesi önerileri (tamamlayıcı yoksa benzer ürünler) ---------- */
  const recsCache = new Map();
  class CartRecs extends HTMLElement {
    async connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      if (!recsCache.has(url)) {
        recsCache.set(url, (async () => {
          for (const intent of ['complementary', 'related']) {
            try {
              const res = await fetch(`${url}&intent=${intent}`);
              if (!res.ok) continue;
              const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
              const inner = doc.querySelector('[data-cart-recs-inner]');
              if (inner && inner.querySelector('li')) return inner.innerHTML;
            } catch (_) { /* sonraki tür */ }
          }
          return '';
        })());
      }
      const html = await recsCache.get(url);
      const slot = this.querySelector('[data-cart-recs-slot]');
      if (!html || !slot || !this.isConnected) return;
      slot.innerHTML = html;
      this.hidden = false;
    }
  }
  customElements.define('cart-recs', CartRecs);

  /* ---------- Hızlı ekle ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.getElementById('QuickAdd');
    const body = drawer && drawer.querySelector('[data-quick-body]');
    if (!body) return (location.href = btn.dataset.quickAdd);
    body.innerHTML = '<div class="qa qa--loading" aria-busy="true"><span class="spinner"></span></div>';
    drawer.open(btn);
    try {
      const doc = await L.fetchSection(btn.dataset.quickAdd, 'quick-add');
      const inner = doc.querySelector('[data-quick-inner]');
      if (!inner) throw new Error('empty');
      body.innerHTML = '';
      body.append(document.importNode(inner, true));
    } catch (_) {
      location.href = btn.dataset.quickAdd;
    }
  });
  document.addEventListener('product:added', (e) => {
    const qa = e.target.closest('#QuickAdd');
    qa && qa.close();
  });

  /* ---------- Sepet çekmecesi ---------- */
  const cartDrawer = () => document.getElementById('CartDrawer');
  const swapDrawer = (html) => {
    const drawer = cartDrawer();
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer-inner]');
    const cur = drawer.querySelector('[data-cart-drawer-inner]');
    if (next && cur) cur.innerHTML = next.innerHTML;
  };
  L.refreshCartDrawer = async () => {
    const res = await fetch(`${cfg.routes.root || '/'}?section_id=cart-drawer`);
    if (res.ok) swapDrawer(await res.text());
  };
  L.openCartDrawer = async (opener) => {
    const drawer = cartDrawer();
    if (!drawer) return (location.href = cfg.routes.cart || '/cart');
    try { await L.refreshCartDrawer(); } catch (_) { /* eski içerikle aç */ }
    drawer.open(opener);
  };
  L.afterAdd = (added) => {
    if (cfg.isCartPage) return location.reload();
    if (cfg.cartType === 'drawer' && cartDrawer()) L.openCartDrawer();
    else L.addedToast(added);
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-drawer-open]');
    if (!opener || cfg.isCartPage || !cartDrawer()) return;
    e.preventDefault();
    L.openCartDrawer(opener);
  });
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#CartDrawer [data-cd-minus], #CartDrawer [data-cd-plus]');
    if (!btn) return;
    const row = btn.closest('[data-line]');
    const qty = Number(row.dataset.qty) + (btn.hasAttribute('data-cd-plus') ? 1 : -1);
    row.classList.add('is-updating');
    try {
      const cart = await L.cart.change(Number(row.dataset.line), Math.max(0, qty), { sections: ['cart-drawer'] });
      swapDrawer(cart.sections && cart.sections['cart-drawer']);
    } catch (err) {
      row.classList.remove('is-updating');
      L.toast({ message: err.message || S.error, icon: false });
    }
  });

  /* ---------- Başlangıç ---------- */
  const init = () => {
    L.favs.sync();
    const viewed = document.querySelector('[data-recent-handle]');
    viewed && L.recent.add(viewed.dataset.recentHandle);
    const hdr = document.querySelector('.section-header');
    if (hdr) {
      const setSticky = () => {
        const sticky = getComputedStyle(hdr).position === 'sticky';
        const top = parseFloat(getComputedStyle(hdr).top) || 0;
        document.documentElement.style.setProperty('--sticky-top', sticky ? Math.max(0, hdr.offsetHeight + top) + 'px' : '0px');
      };
      setSticky();
      new ResizeObserver(setSticky).observe(hdr);
      window.addEventListener('resize', L.debounce(setSticky, 100));
    }
    if (matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('.footer__acc[open]').forEach((d) => d.removeAttribute('open'));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (e) => L.favs.sync(e.target));
})();
